export interface SpellcheckKindColor {
  dot: string;
  pillBg: string;
  pillText: string;
  tint: string;
}

const SPELLCHECK_KIND_COLORS: Record<string, SpellcheckKindColor> = {
  Miscellaneous: { dot: '#0284c7', pillBg: '#f0f9ff', pillText: '#0369a1', tint: '#e0f2fe' },
  Repetition: { dot: '#b45309', pillBg: '#fffbeb', pillText: '#b45309', tint: '#fef3c7' },
  Spelling: { dot: '#e11d48', pillBg: '#fff1f2', pillText: '#be123c', tint: '#ffe4e6' },
  Style: { dot: '#2563eb', pillBg: '#eff6ff', pillText: '#1d4ed8', tint: '#dbeafe' },
  Typo: { dot: '#dc2626', pillBg: '#fef2f2', pillText: '#b91c1c', tint: '#fee2e2' },
  'Word Choice': { dot: '#4f46e5', pillBg: '#eef2ff', pillText: '#4338ca', tint: '#e0e7ff' },
};

const NEUTRAL_SPELLCHECK_KIND_COLOR: SpellcheckKindColor = {
  dot: '#78716c',
  pillBg: '#f5f5f4',
  pillText: '#44403c',
  tint: '#e7e5e4',
};

export function getSpellcheckKindColor(kind: string): SpellcheckKindColor {
  return SPELLCHECK_KIND_COLORS[kind] ?? NEUTRAL_SPELLCHECK_KIND_COLOR;
}
